module.exports = __webpack_public_path__ + "static/img/6.e5b1069.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6.jpeg
// module id = xt+u
// module chunks = 0